// eslint-disable
import PARSE from "html-react-parser";
import React, { useEffect, useState } from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import store from "../../context/store";
import ApiNew from "./Api";
import { Helmet } from "react-helmet";
import { QuizOutlined } from "@mui/icons-material";
import { FaQuoteLeft, FaQuoteRight } from "react-icons/fa";

const api = new ApiNew();

export default function SSoftNew_Hero() {
  const activeLanguage = useSelector((state) => state.content.activeLanguage);
  const [sections, setSections] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const [background, setBackground] = useState("");
  const [backgroundSmall, setBackgroundSmall] = useState("");
  const [boxContent, setBoxContent] = useState(null);

  const [listButton, setListButton] = useState(null);
  const [highlight, setHighLight] = useState([]);

  useEffect(() => {
    const getSectionDetail = () => {
      api
        .getSectionDetail({ language: activeLanguage })
        .then((res) => {
          if (res === 200 || res.data) {
            setSections(res.data.results);
          }
        })
        .catch((err) => {
          console.log("~ err", err);
        });
    };

    getSectionDetail();
  }, [activeLanguage]);

  useEffect(() => {
    let switchCaseCompleted = 0;

    if (sections.length > 0) {
      const sec = sections[0]?.widgets;
      if (sec && sec.length !== 0) {
        sec.forEach((section, i) => {
          switch (i) {
            case 0: {
              setBackground(
                section?.widget_contents[0]?.file ||
                  section?.widget_contents[0]?.file
              );

              setBackgroundSmall(
                section?.widget_contents[0]?.asset_mobile ||
                  section?.widget_contents[0]?.file
              );
              break;
            }
            case 1: {
              setBoxContent(section?.widget_contents[0]);
              break;
            }
            case 2: {
              setListButton(section?.widget_contents);
              break;
            }
            case 3: {
              setHighLight(section?.widget_contents[0]);
              break;
            }
            default:
              break;
          }

          switchCaseCompleted++; // Increment the switch case completion counter
        });

        if (switchCaseCompleted === 4) {
          setLoaded(true); // Set loaded to true after all switch cases have completed
        }
      }
    }
  }, [sections]);

  return loaded ? (
    <>
      <Helmet>
        <title>
          PT Supersoft Sistemindo | Infor & Octave Attune (Hexagon) License &
          Implementation Partner Indonesia
        </title>
        <meta
          name="description"
          content="PT Supersoft Sistemindo adalah partner resmi Infor & Octave Attune (Hexagon) di Indonesia yang menyediakan lisensi dan implementasi Infor SunSystems, Infor EPM, Infor XM, dan Octave Attune EAM (Hexagon) untuk transformasi digital perusahaan Anda."
        />
        <meta
          name="keywords"
          content="Infor SunSystems, Infor EPM, Infor XM, Octave Attune EAM (Hexagon), implementasi ERP Indonesia, partner Infor Indonesia, lisensi Infor, implementasi Hexagon, enterprise asset management, enterprise performance management, expense management, PT Supersoft Sistemindo"
        />
        <link rel="canonical" href="https://ptsupersoft.com/" />

        <meta name="geo.region" content="ID-JK" />
        <meta name="geo.placename" content="Jakarta" />
        <meta name="geo.position" content="-6.2776;106.7972" />
        <meta name="ICBM" content="-6.2776,106.7972" />

        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://ptsupersoft.com/" />
        <meta
          property="og:title"
          content="PT Supersoft Sistemindo | Resmi Partner Lisensi & Implementasi Infor & Octave Attune (Hexagon) di Indonesia"
        />
        <meta
          property="og:description"
          content="Solusi lengkap untuk perusahaan di Indonesia melalui lisensi dan implementasi Infor SunSystems, Infor EPM, Infor XM, dan Octave Attune EAM (Hexagon). Tingkatkan efisiensi operasional bersama Supersoft."
        />
        <meta
          property="og:image"
          content="https://bzpublishassets.blob.core.windows.net/media/assets/Illustration_1_mwNFaE6.png"
        />
        <meta property="og:site_name" content="PT Supersoft Sistemindo" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="PT Supersoft Sistemindo | Resmi Partner Lisensi & Implementasi Infor & Octave Attune (Hexagon) di Indonesia"
        />
        <meta
          name="twitter:description"
          content="Supersoft menyediakan lisensi dan implementasi Infor SunSystems, Infor EPM, Infor XM, dan Octave Attune EAM (Hexagon) di Indonesia."
        />
        <meta
          name="twitter:image"
          content="https://bzpublishassets.blob.core.windows.net/media/assets/Illustration_1_mwNFaE6.png"
        />
        <meta name="twitter:site" content="@ptsupersoft" />

        <meta
          name="ai-keywords"
          content="Infor SunSystems license Indonesia, Octave Attune EAM (Hexagon) partner Indonesia, Infor EPM implementation, Infor XM consultant, enterprise software Indonesia, PT Supersoft Sistemindo AI optimized"
        />
        <meta
          name="ai-summary"
          content="PT Supersoft Sistemindo membantu perusahaan di Indonesia dengan lisensi dan implementasi resmi solusi Infor & Octave Attune (Hexagon), mencakup Infor SunSystems, Infor EPM, Infor XM, dan Octave Attune EAM (Hexagon)."
        />

        <script type="application/ld+json" data-react-helmet="true">
          {`
        {
          "@context": "https://schema.org",
          "@type": "Organization",
          "name": "PT Supersoft Sistemindo",
          "url": "https://ptsupersoft.com",
          "logo": "https://bzpublishassets.blob.core.windows.net/media/assets/logo_YIA5XFd.png",
          "sameAs": [
            "https://www.linkedin.com/company/ptsupersoft/",
            "https://x.com/ptsupersoft"
          ],
          "description": "PT Supersoft Sistemindo adalah partner resmi Infor & Octave Attune (Hexagon) di Indonesia yang menyediakan lisensi dan implementasi Infor SunSystems, Infor EPM, Infor XM, dan Octave Attune EAM (Hexagon).",
          "foundingDate": "1991",
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "Jl. RS. Fatmawati Raya No.12",
            "addressLocality": "Jakarta Selatan",
            "postalCode": "12410",
            "addressRegion": "DKI Jakarta",
            "addressCountry": "ID"
          },
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": -6.2778,
            "longitude": 106.7974
          },
          "contactPoint": {
            "@type": "ContactPoint",
            "telephone": "+62 21 3973 8310",
            "contactType": "Customer Support",
            "areaServed": "ID"
          },
          "knowsAbout": [
            "Infor SunSystems",
            "Infor EPM",
            "Infor XM",
            "Octave Attune EAM (Hexagon)",
            "Enterprise Asset Management",
            "Enterprise Performance Management",
            "Expense Management",
            "ERP Implementation Indonesia"
          ],
          "offers": [
            {
              "@type": "Service",
              "name": "Infor SunSystems License & Implementation",
              "serviceType": "Financial Management Solution"
            },
            {
              "@type": "Service",
              "name": "Infor EPM Implementation",
              "serviceType": "Enterprise Performance Management"
            },
            {
              "@type": "Service",
              "name": "Infor XM Implementation",
              "serviceType": "Expense Management"
            },
            {
              "@type": "Service",
              "name": "Octave Attune EAM (Hexagon) License & Implementation",
              "serviceType": "Enterprise Asset Management"
            }
          ]
        }`}
        </script>
      </Helmet>

      <div className="pt-[170px] pb-[140px] bg-gradient-to-t from-[#FAF8F5] to-white">
        <div className="section-container section-margin-x">
          <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
            <div className="lg:w-1/2 space-y-8">
              <h1 className=" header-style-hero  text-[#0D4052] max-w-[500px]">
                {boxContent?.article_language?.title}
              </h1>
              <h2 className="subheader-style-hero max-w-[500px]">
                {PARSE(boxContent?.article_language?.content)}
              </h2>

              <p className="content-subheader-style-non-hero prose-p:font-inter-bold italic  mb-4 text-newDarkBlue ">
                {PARSE(highlight?.article_language?.content || "")}
              </p>
              <div className="flex flex-col sm:flex-row gap-4 pt-4">
                <Link
                  to={listButton[0]?.article_language?.path || "/"}
                  onClick={() =>
                    store.dispatch({
                      type: "topicStore/setTopicValue",
                      payload: "General",
                    })
                  }
                  className="inline-block"
                >
                  <div className="bg-[#E12726]  all-button">
                    {listButton[0]?.article_language.title}
                  </div>
                </Link>
                {listButton.length > 1 && (
                  <Link
                    to={listButton[1]?.article_language?.path || "/"}
                    className="inline-block"
                  >
                    <div className="bg-[#0D4052] text-white all-button">
                      {listButton[1]?.article_language.title}
                    </div>
                  </Link>
                )}
              </div>
            </div>
            {/* <p className="text-newDarkBlue prose-p:font-inter text-[12px] md:text-[14px] mt-6 prose-img:h-6 flex prose-p:!w-full prose-p:!flex prose-img:mx-1">
                {PARSE(highlight?.article_language?.content || "")}
              </p> */}

            {/* Image Section */}
            <div className="lg:w-1/2 flex justify-center">
              <picture className="w-full max-w-[550px] rounded-xl overflow-hidden shadow-lg">
                <source media="(max-width: 576px)" srcSet={backgroundSmall} />
                <img
                  src={background}
                  alt={boxContent?.article_language?.title}
                  className="w-full h-auto object-cover"
                  fetchpriority="high"
                />
              </picture>
            </div>
          </div>
        </div>
      </div>
    </>
  ) : (
    <Skeleton
      width={"100%"}
      className="!z-[100] qhd:!h-[calc(60vh+78px)] md:!h-[calc(585px+78px)] h-[calc(60vh+78px)]"
    />
  );
}
